/** Shared helpers for project identity/display in the app shell. */

export function getProjectId(project) {
  if (!project) return null;
  const id = project.project_id ?? project.id;
  return id == null ? null : id;
}

export function getProjectName(project) {
  if (!project) return 'Unnamed Project';
  return project.name || project.project_name || 'Unnamed Project';
}

export function isSameProject(a, b) {
  const idA = getProjectId(a);
  const idB = getProjectId(b);
  if (idA == null || idB == null) return false;
  return String(idA) === String(idB);
}

export function findProjectInList(projects, selectedProject) {
  if (!selectedProject) return null;
  return (Array.isArray(projects) ? projects : []).find((project) =>
    isSameProject(project, selectedProject)
  ) || null;
}

export function sortProjectsByName(projects) {
  return [...projects].sort((left, right) =>
    getProjectName(left).localeCompare(getProjectName(right), undefined, { sensitivity: 'base' })
  );
}
